import store from "store2";

const state = {
  logAs: store.get("logAs") || null,
  communicate: store.get("communicate") || null,
  hasUserPassword: store.get("hasUserPassword") || false,
};

const getters = {
  logAs: (state) => state.logAs,
  communicate: (state) => state.communicate,
  hasUserPassword: (state) => state.hasUserPassword,
};

const mutations = {
  SET_LOG_AS(state, value) {
    state.logAs = value;
    store.set("logAs", value);
  },
  SET_COMMUNICATE(state, value) {
    state.communicate = value;
    store.set("communicate", value);
  },
  SET_HAS_USER_PASSWORD(state, value) {
    state.hasUserPassword = value;
    store.set("hasUserPassword", value);
  },
};

const actions = {
  setLogAs({ commit }, value) {
    if (value?.id) {
      commit("SET_LOG_AS", `Log as ${value.firstName} ${value.lastName} [${value.id}]`);
    } else {
      commit("SET_LOG_AS", null);
    }
  },
  setCommunicate({ commit }, value) {
    if (value !== null) {
      commit("SET_COMMUNICATE", `${value}`);
    } else {
      commit("SET_COMMUNICATE", null);
    }
  },
  setHasUserPassword({commit}, value) {
    commit("SET_HAS_USER_PASSWORD", value);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
